import { i18n } from '../../i18n/translate';
import type { MenuEnvironment, MenuItem } from './types';

export const everfiAdminLeft = (environment: MenuEnvironment): MenuItem => {
  const { MENU_DOMAIN_FOR_FRONT_END } = environment;

  return {
    id: 'foundry--universal_navigation--menus--everfi_admin_left',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--everfi_admin_left',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    submenu_items: [
      {
        id: '',
        slug: '',
        module: 'adminifi',
        title: i18n.t('Home'),
        icon: 'house-chimney',
        font_family: '',
        css_class: '',
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        module: 'adminifi',
        title: i18n.t('Organizations'),
        icon: 'buildings',
        font_family: '',
        css_class: '',
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/organizations`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        module: 'adminifi',
        title: i18n.t('Foundry Users'),
        icon: 'user-group',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['view_users'] }],
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/foundry_users`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        module: 'adminifi',
        title: i18n.t('Report Configs'),
        icon: 'chart-column',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['manage_reports'] }],
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/report_configs`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        module: 'adminifi',
        title: i18n.t('Benchmarks'),
        icon: 'tag',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['manage_benchmarks'] }],
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/benchmarks`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        module: 'adminifi',
        title: i18n.t('System Messages'),
        icon: 'triangle-exclamation',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['manage_system_messages', 'view_system_messages'] }],
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/system_messages`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        module: 'adminifi',
        title: i18n.t('Administrators'),
        icon: 'user-group-crown',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['manage_administrators'] }],
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/administrators`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        slug: '',
        module: 'notifi',
        title: i18n.t('Notifi'),
        icon: 'bell-on',
        font_family: '',
        css_class: '',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: false,
        weight: 100,
        submenu_items: [
          {
            id: '',
            slug: '',
            title: i18n.t('Templates'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [
              { admin_has_permission: ['manage_notifi', 'manage_email_templates'] },
              { has_rule_set_role: ['he_cc_fs_primary_managers'] },
            ],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/templates`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Layouts'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [
              { admin_has_permission: ['manage_notifi', 'manage_email_templates'] },
              { has_rule_set_role: ['he_cc_fs_primary_managers'] },
            ],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/layouts`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Suppression Lists'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['manage_notifi'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/suppression_lists`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Bounced Emails'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['view_notifi_bounces'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/bounced_emails`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Send Mail Servers'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['manage_custom_smtp'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/send_mail_servers`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
        ],
      },
      {
        id: '',
        slug: '',
        module: 'content-service',
        title: i18n.t('Content'),
        icon: 'films',
        font_family: '',
        css_class: '',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: false,
        weight: 100,
        submenu_items: [
          {
            id: '',
            slug: '',
            title: i18n.t('Catalog'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [
              { admin_has_permission: ['manage_content', 'view_content_config', 'customize_courses', 'view_content'] },
              { has_rule_set_role: ['he_cc_fs_primary_managers'] },
            ],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/contents`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Certificates'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['manage_certificates'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/content_award_rules`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Configurations'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [
              { admin_has_permission: ['view_content_config', 'manage_content_config'] },
              { has_rule_set_role: ['he_cc_fs_primary_managers'] },
            ],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/content_configs`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Content Packages'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [
              {
                admin_has_permission: [
                  'manage_content',
                  'view_content',
                  'view_content_packages',
                  'assign_content_packages',
                ],
              },
              { has_rule_set_role: ['he_cc_fs_primary_managers'] },
            ],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/content_packages`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('National Resources'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [
              { admin_has_permission: ['manage_content', 'view_national_resources'] },
              { has_rule_set_role: ['he_cc_fs_primary_managers'] },
            ],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/business_resources`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Customer Resources'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['manage_customer_resources', 'view_customer_resources'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/customer_resources`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Scorm Content Packages'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [
              { admin_has_permission: ['manage_content', 'manage_scorm'] },
              { has_rule_set_role: ['he_cc_fs_primary_managers'] },
            ],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/scorm_packages`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
        ],
      },
      {
        id: '',
        slug: '',
        module: 'evalufi',
        title: i18n.t('Evaluations'),
        icon: 'list',
        font_family: '',
        css_class: '',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: false,
        weight: 100,
        submenu_items: [
          {
            id: '',
            slug: '',
            title: i18n.t('Assessments'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [
              { admin_has_permission: ['manage_evaluations', 'manage_evaluation_assessments', 'view_evaluations'] },
            ],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/assessments`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Forms'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['view_evaluations', 'manage_evaluation_forms'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/forms`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Surveys'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['view_evaluations', 'manage_evaluation_surveys'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/surveys`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Polls'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['view_evaluations', 'manage_evaluation_polls'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/polls`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
        ],
      },
      {
        id: '',
        slug: '',
        module: 'k12',
        title: i18n.t('Opportunities'),
        icon: 'trophy',
        font_family: '',
        css_class: '',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: false,
        weight: 100,
        submenu_items: [
          {
            id: '',
            slug: '',
            title: i18n.t('Scholarships'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['view_scholarships', 'manage_scholarships'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/scholarships`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Timelines'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['view_timelines', 'manage_timelines'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/timelines`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: i18n.t('Audiences'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['view_audiences', 'manage_audiences'] }],
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/audiences`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
        ],
      },
      {
        id: '',
        slug: '',
        module: 'certificate-service',
        title: i18n.t('Awards'),
        icon: 'shield-check',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['manage_certificates'] }],
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin/awards`,
        target_method: '',
        new_window: false,
        subsection: false,
        weight: 100,
        submenu_items: [],
      },
    ],
  };
};
